import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { BsRobot } from "react-icons/bs";
import { BsBarChart } from "react-icons/bs";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am passionate about Machine Learning and Artificial Intelligence, 
              constantly exploring the frontiers of what's possible with data and algorithms.
              <br />
              <br />I am proficient in programming languages like
              <i>
                <b className="purple"> Python, C++, Java, and SQL. </b>
              </i>
              <br />
              <br />
              My expertise lies in &nbsp;
              <i>
                <b className="purple">Deep Learning, Computer Vision, and NLP </b> with
                experience in{" "}
                <b className="purple">
                  Large Language Models and Fine-tuning.
                </b>
              </i>
              <br />
              <br />
              I specialize in developing AI solutions using <b className="purple">PyTorch</b> and
              <i>
                <b className="purple">
                  {" "}
                  modern ML frameworks
                </b>
              </i>
              &nbsp; for
              <i>
                <b className="purple"> real-world applications</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/devbm7"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/DevBMakwana"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/dev-makwana-1a2066227/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://huggingface.co/DevBM"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <BsRobot />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.kaggle.com/channingfisher"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <BsBarChart />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
